/**
 * lib-core
 *
 * Adapptio Core library.
 *
 * @package lib-core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { ItemRegistry, ItemRegistryItemProps } from "@adapptio/lib-shared";

/**
 * Route Registry Item props
 */
export interface IRouteRegistryItemProps extends ItemRegistryItemProps {
	/** Path */
	path: string;
	/** Route label */
	label: string;
}

/**
 * Routes Registry
 */
export type IRoutesRegistry = ItemRegistry<IRouteRegistryItemProps>;

export class RoutesRegistry extends ItemRegistry<IRouteRegistryItemProps> {}
